module.exports = __webpack_public_path__ + "static/media/transport_travel-min.5ff36dcb.jpg";